import { BaseGraphQL } from "~/services/baseGraphQL";
import { GRAPHQL_AUTHENTICATION } from "~/constants/url";
import { JsonResponseType } from "~/types/jsonResponseType";
import { ChangePasswordInput } from "../types/changePassword";
const authenticationGraph = BaseGraphQL({
  baseUrl: GRAPHQL_AUTHENTICATION,
});

export const changePassword = async (input: ChangePasswordInput) => {
  const query = `
       query changePassword(
      $password: String!
      $newPassword: String!
    ) {
      authenticate {
        changePassword(
          changePasswordVM: {
            password: $password
            newPassword: $newPassword
          }
        ) {
          succeed
          messageCode
        }
      }
    }
  `;

  return await authenticationGraph<
    { succeed: boolean; messageCode: string },
    {
      authenticate: {
        changePassword: JsonResponseType<{
          succeed: boolean;
          messageCode: string;
        }>;
      };
    }
  >(
    {
      action: "UserGraphQL",
      query,
      variables: { ...input },
    },
    (input) => input.authenticate.changePassword,
  );
};
